import React, { useState, useEffect } from "react";
import "../DarkMode.css";
import { Link } from "react-router-dom";
import "./NavBarStyles.css";
import { Hamburger } from "../pages/Hamburguer";
import { Logo } from "../pages/Logo";
import sun from '../Assets/sun.png';
import moon from '../Assets/moon.png';



export const Navbar = ({ mode }) => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <Logo />
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>
        <div className={`nav-elements ${showNavbar ? "active" : ""}`}>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/education">Education</Link>
            </li>
            <li>
              <Link to="/experience">Experience</Link>
            </li>
            <li>
              <Link to="/certifications">Certifications</Link>
            </li>
            <li>
              <Link to="/portfolio">Portfolio</Link>
            </li>
            <li>
              <Link to="/skills">Skills</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <div className="mode-d">
                <img src={sun} alt="icon" className='sun' />
                
              <input type="checkbox" id="toggle" onClick={mode}></input>
                   <img src={moon} alt="icon" className='sun' />
                   </div>
            </li>
            
          </ul>
        </div>
      </div>
    </nav>
  );
};
